(function() {
'use strict';

angular
    .module('searchUnit')
    .factory('sharedSearchUnitService', sharedSearchUnitService);

function sharedSearchUnitService(
    $route,
    $routeParams,
    $q,
    tripService,
    basketService,
    Area,
    broker,
    $rootScope,
    resourceService) {
    const delayedLinkers = {};
    const areasInfo = Area;

    const service = {
        addDelayedLinker,
        getAreaInfo,
        initializeArea,
        search,
        showErrors,
        lockScreen,
        unlockScreen
    };

    function addDelayedLinker(linkerFn, key) {
        delayedLinkers[key] = linkerFn;
    }

    function getAreaInfo(areaOverride) {
        return areasInfo[(areaOverride || ($route.current && $route.current.$$route ? $route.current.$$route.area : ''))];
    }

    function initializeArea(scope, el, attr, controller, key) {
        const tripId = $routeParams.tripId;
        const areaPromise = tripId ? tripService.getTrip(tripId) : $q.when();

        areaPromise.then(function loadCriteriaWrapper() {
            _loadCriteria(scope, el, attr, controller, key);
        });
    }

    function search(getSearchResultsFn, showErrorsFn, options, searchModel, isFlexibleTripType) {
        if (!options) { options = {}; }

        const params = {
            multi: options.multi || false,
            legs: options.legs || null,
            samePage: options.samePage,
            oneWayOnly: options.onewayonly,
            estabId: options.estabId,
            defaultFilters: options.defaultFilters,
            roomSearch: options.roomSearch,
            fid: options.fid,
            fbt: options.fbt,
            fstr: options.fstr,
            hpr: options.hpr,
            flexibleDates: options.flexibleDates,
            prefilterAirlines: options.prefilterAirlines,
            prefilterDirectFlights: options.prefilterDirectFlights,
            enableTransfersTimeApproval: options.enableTransfersTimeApproval,
            postfilterAirlines: options.postfilterAirlines,
            searchModel,
            isFlexibleTripType
        };

        return basketService.startWorkflow(getAreaInfo(options.areaOverride).flow, params)
            .then(getSearchResultsFn, showErrorsFn);
    }

    function _loadCriteria(scope, el, attr, controller, key) {
        function _delayedLinkerWrapper() {
            delayedLinkers[key].call(undefined, scope, el, attr, controller);
        }

        _delayedLinkerWrapper();
    }

    function showErrors(errors) {
        broker.publish('unblock');
        $rootScope.$emit('unblock');
        $rootScope.$broadcast('flash:error', errors);
    }

    function lockScreen(searchMsg, loadingScreenStyle) {
        $rootScope.$emit('block', {
            title: resourceService.get(searchMsg),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle
        });

        $rootScope.$broadcast('flash:hide');
    }

    function unlockScreen() {
        $rootScope.unlockScreen($rootScope);
    }

    return service;
}
})();
